import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function MintMojito() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section className="recipe-hero-anim" style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          padding: "60px 0 40px 0"
        }}>
          <h1 className="recipe-title-anim" style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Mint Mojito</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 16 }}>A cool, minty refreshment.</p>
          <span className="season-badge season-summer">☀️ Best in Summer</span>
          <ImageWithFallback src="/mint-mojito.jpg" alt="Mint Mojito" className="recipe-image-anim" style={{ width: 340, borderRadius: 24, boxShadow: "0 4px 32px rgba(0,0,0,0.10)", marginBottom: 24, marginTop: 20 }} />
          <div style={{ fontSize: "1.1rem", color: "#555", maxWidth: 600, textAlign: "center" }}>
            Try this refreshing mint mojito recipe!
          </div>
          <div className="recipe-columns-anim" style={{
            fontSize: "1.1rem",
            color: "#555",
            maxWidth: 600,
            textAlign: "center",
            marginTop: 24
          }}>
            <h2 style={{ fontSize: "1.5rem", fontWeight: "bold", marginBottom: 12 }}>Recipe</h2>
            <ul className="ingredient-list" style={{ textAlign: "left", marginBottom: 16 }}>
              <li>Fresh mint leaves</li>
              <li>1 lime, sliced</li>
              <li>2 tablespoons sugar</li>
              <li>1 cup soda water</li>
              <li>Ice cubes</li>
            </ul>
            <p style={{ textAlign: "left" }}>
              Muddle mint leaves, lime slices, and sugar in a glass. Add ice cubes and soda water. Stir well and enjoy!
            </p>
          </div>
          <div style={{ maxWidth: 600, width: "100%", marginTop: 32, display: "flex", flexDirection: "column", gap: 24 }}>
            <div className="chef-tips-box" style={{ background: "#f8f9fa", padding: 20, borderRadius: 12, textAlign: "left" }}>
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Slap the mint leaves between your palms before muddling — it releases the oils without bruising them bitter.</li>
                <li>Use superfine sugar so it dissolves fully without a gritty texture.</li>
                <li>Muddle gently; over-muddling mint turns the drink cloudy and slightly bitter.</li>
                <li>Top with soda water last and pour slowly to keep the fizz.</li>
                <li>Garnish with a mint sprig and a lime wheel for a café-style presentation.</li>
              </ul>
            </div>
            <div className="health-benefits-box" style={{ background: "#eef9f0", padding: 20, borderRadius: 12, textAlign: "left" }}>
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Mint is known to soothe digestion and can ease bloating after a meal.</li>
                <li>Lime provides a good dose of vitamin C to support the immune system.</li>
                <li>Being alcohol-free and lightly sweetened, it's a refreshing way to stay hydrated in the heat.</li>
                <li>Soda water adds fizz without the sugar load of regular soft drinks.</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default MintMojito;
